module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel-tiergesundheit.da3faf16.png";